import { useContext } from 'react';

import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';
import { useSelector } from 'src/hooks/useSelector';
import { NegotiationTopic } from 'src/models/negotiationTopic.types';
import { LastTopicState } from 'src/models/resumeCard';

export const useTopicState = (): NegotiationTopic | LastTopicState | null => {
    const { lastTopicState, topicId } = useContext(ResumeCardActionsContext).resume;
    const responseTopicState = useSelector((state) => state.candidatesList?.shortTopicList?.topicList?.[topicId || '']);

    return responseTopicState || lastTopicState || null;
};
